/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_NewsInputs */

const en_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

const fr_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelles`)
};

const de_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

const it_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizia`)
};

const ru_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новости`)
};

const es_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noticias`)
};

const zh_cn2_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息`)
};

const ja_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ニュース`)
};

const hi_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाचार`)
};

const pt_pt2_subtitle_export_keyword_news = /** @type {(inputs: Subtitle_Export_Keyword_NewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notícias`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Subtitle_Export_Keyword_NewsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_news = /** @type {((inputs?: Subtitle_Export_Keyword_NewsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_NewsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_news(inputs)
	if (locale === "de") return de_subtitle_export_keyword_news(inputs)
	if (locale === "it") return it_subtitle_export_keyword_news(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_news(inputs)
	if (locale === "es") return es_subtitle_export_keyword_news(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_news(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_news(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_news(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_news(inputs)
	return en_subtitle_export_keyword_news(inputs)
});